import clearTime from '@/utils/helpers/clear-time-from-date';

export const isTomorrow = (date: Date) => {
  const argDate = clearTime(date).getTime();
  const tomorrow = clearTime(new Date());
  tomorrow.setDate(tomorrow.getDate() + 1);

  return tomorrow.getTime() === argDate;
};
